/** @format */

import {ChartIds} from '../models/chartIds';
import {GraphStat} from '../models/common';
import {
  ALL_BUDGET_CHART_IDS,
  ALL_PROPERTY_IDS,
  ALL_SENSOR_CHART_IDS,
} from '../constants/allChartIds';

const getAllChartIdsPoint = (graphStat?: GraphStat): ChartIds[] => {
  if (!graphStat) {
    return [];
  }

  const result: ChartIds[] = [];

  const graphKeys = Object.keys(graphStat) as ChartIds[];
  graphKeys.forEach(key => {
    // todo Временное решение проблемы с актуальностью id
    // Будет решено в задаче https://adsensor-ru.atlassian.net/browse/AS-7003
    if ([...ALL_PROPERTY_IDS, ...ALL_SENSOR_CHART_IDS, ...ALL_BUDGET_CHART_IDS].includes(key)) {
      result.push(key);
    }
  });

  return result;
};

export default getAllChartIdsPoint;
